
export enum AppMode {
  LANDING = 'LANDING',
  DASHBOARD = 'DASHBOARD',
  UPLOAD = 'UPLOAD',
  PROCESSING = 'PROCESSING',
  RESULT = 'RESULT',
  LIGHTBOX = 'LIGHTBOX', 
  PROFILE = 'PROFILE',
  TUTORIALS = 'TUTORIALS'
}

export interface ProcessingStep {
  message: string;
  duration: number;
}

export interface GeneratedImage {
  id: string;
  url: string;
  timestamp: number;
  label: string;
  config?: TransformationConfig; 
  folderId?: string; 
  projectId?: string;
  isFavorite?: boolean;
  userId?: string; 
}

export interface Preset {
    id: string;
    name: string;
    config: TransformationConfig;
    createdAt: number;
    userId?: string; 
}

export interface SavedAsset {
  id: string;
  user_id?: string; 
  type: 'background' | 'prop';
  url: string; 
  label: string;
  timestamp: number;
}

export interface Folder {
    id: string;
    name: string;
    createdAt: number;
}

export interface TransformationConfig {
  backgroundMode: 'keep' | 'change';
  backgroundDescription?: string;
  backgroundColor?: string;
  backgroundRefImage?: File;
  
  propMode: 'keep' | 'change';
  propDescription?: string;
  propRefImage?: File; 
  propRefImages?: File[]; 
  
  framingMode?: 'keep' | 'change';
  framing?: string;
  
  angleMode?: 'keep' | 'change';
  angle?: string;
  
  aspectRatioMode?: 'keep' | 'change';
  aspectRatio?: '1:1' | '3:4' | '4:3' | '9:16' | '16:9';

  cameraType?: string;
  lighting?: string;
  poseCategory?: string;
  poseDescription?: string; 

  retouching?: 'Light' | 'Moderate' | 'Extreme';
  critique?: string;
  outputResolution?: '1K' | '2K' | '4K';
}

export interface VariationItem {
    id: string;
    url: string;
    isFavorite: boolean;
}

export const PROCESSING_STEPS: ProcessingStep[] = [
  { message: "Analyzing Light Physics...", duration: 2500 },
  { message: "Simulating 150MP Sensor...", duration: 2500 },
  { message: "Rebuilding Geometry...", duration: 2500 },
  { message: "Applying Color Grade...", duration: 2500 },
  { message: "Finalizing Development...", duration: 2000 },
];
